import { ReactComponent as ErrorImage } from '../../assets/images/error.svg';

import { Flex, Text } from '@amigoapp/doca-react';

const Error = ({ message = 'Não foi possível carregar as informações do teleatendimento.' }) => (
	<Flex align="center" className="doca-text--center" direction="col" flex={1} gap={6} justify="center">
		<ErrorImage alt="error" width={250} />
		<Text variant="gray">{message}</Text>
	</Flex>
);

export default Error;
